export default __webpack_public_path__ + "static/media/3.142688b9.jpg";